"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEAltBeaconBuilder = exports.BLEAltBeacon = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLEUUID_1 = require("./BLEUUID");
const BLEBeaconObject_1 = require("./BLEBeaconObject");
const BufferUtils_1 = require("../utils/BufferUtils");
let BLEAltBeacon = class BLEAltBeacon extends BLEBeaconObject_1.BLEBeaconObject {
    get proximityUUID() {
        if (this.beaconId) {
            return BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(this.beaconId.toBuffer().buffer.slice(0, 16)));
        }
        else {
            return undefined;
        }
    }
    set proximityUUID(uuid) {
        if (!this.beaconId) {
            this.beaconId = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(20));
        }
        const uuidView = new DataView(uuid.toBuffer().buffer);
        const view = new DataView(this.beaconId.toBuffer().buffer);
        for (let i = 0; i < 16; i++) {
            view.setUint8(i, uuidView.getUint8(i));
        }
    }
    get major() {
        if (this.beaconId) {
            const view = new DataView(this.beaconId.toBuffer().buffer);
            return view.getUint16(16);
        }
        else {
            return undefined;
        }
    }
    set major(value) {
        if (!this.beaconId) {
            this.beaconId = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(20));
        }
        const view = new DataView(this.beaconId.toBuffer().buffer);
        view.setUint16(16, value);
    }
    get minor() {
        if (this.beaconId) {
            const view = new DataView(this.beaconId.toBuffer().buffer);
            return view.getUint16(18);
        }
        else {
            return undefined;
        }
    }
    set minor(value) {
        if (!this.beaconId) {
            this.beaconId = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(20));
        }
        const view = new DataView(this.beaconId.toBuffer().buffer);
        view.setUint16(18, value);
    }
    isValid() {
        return this.beaconId !== undefined;
    }
    computeUID() {
        let uid = new TextDecoder().decode(this.beaconId.toBuffer());
        uid = (0, BufferUtils_1.toHexString)(this.beaconId.toBuffer());
        return uid;
    }
    parseManufacturerData(_, manufacturerData) {
        super.parseManufacturerData(_, manufacturerData);
        if (!manufacturerData) {
            return this;
        }
        const view = new DataView(manufacturerData.buffer, 0);
        if (manufacturerData.byteLength < 24 ||
            !(0, BufferUtils_1.arrayBuffersAreEqual)(manufacturerData.buffer.slice(0, 2), Uint8Array.from([0xbe, 0xac]).buffer)) {
            return this;
        }
        this.beaconId = BLEUUID_1.BLEUUID.fromBuffer(manufacturerData.slice(2, 22));
        this.calibratedRSSI = view.getInt8(22);
        this.msb = view.getInt8(23);
        if (this.uid === undefined) {
            this.uid = this.computeUID();
        }
        return this;
    }
};
exports.BLEAltBeacon = BLEAltBeacon;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", BLEUUID_1.BLEUUID)
], BLEAltBeacon.prototype, "beaconId", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEAltBeacon.prototype, "msb", void 0);
exports.BLEAltBeacon = BLEAltBeacon = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], BLEAltBeacon);
/**
 * BLE AltBeacon builder
 */
class BLEAltBeaconBuilder extends BLEBeaconObject_1.BLEBeaconBuilder {
    constructor() {
        super();
        this.manufacturer = 0xffff;
        this.beacon = new BLEAltBeacon();
        this.beacon.proximityUUID = BLEUUID_1.BLEUUID.fromString(core_1.UUID.generate().toString());
        this.beacon.major = 0;
        this.beacon.minor = 0;
    }
    static create() {
        return new BLEAltBeaconBuilder();
    }
    static fromBeacon(beacon) {
        const builder = new BLEAltBeaconBuilder();
        builder.beacon = beacon;
        builder.manufacturer = beacon.manufacturerData.size > 0 ? beacon.manufacturerData.keys().next().value : 0xffff;
        return builder;
    }
    manufacturerId(manufacturer) {
        this.manufacturer = manufacturer;
        return this;
    }
    beaconId(beaconId) {
        this.beacon.beaconId = beaconId;
        return this;
    }
    proximityUUID(uuid) {
        this.beacon.proximityUUID = uuid;
        return this;
    }
    major(major) {
        this.beacon.major = major;
        return this;
    }
    minor(minor) {
        this.beacon.minor = minor;
        return this;
    }
    build() {
        return new Promise((resolve) => {
            // Compute manufacturer data
            const manufacturerData = new DataView(new ArrayBuffer(24), 0);
            // Advertisement data
            manufacturerData.setUint8(0, 0xbe); // Beacon code
            manufacturerData.setUint8(1, 0xac);
            // Beacon ID
            const beaconId = new DataView(this.beacon.beaconId.toBuffer().buffer, 0);
            for (let i = 2; i < 2 + 20; i++) {
                manufacturerData.setUint8(i, beaconId.getUint8(i - 2));
            }
            manufacturerData.setInt8(22, this.beacon.calibratedRSSI); // Calibrated RSSI
            manufacturerData.setUint8(23, this.beacon.msb);
            this.beacon.beaconId = BLEUUID_1.BLEUUID.fromBuffer(new Uint8Array(manufacturerData.buffer.slice(2, 22)));
            this.beacon.manufacturerData.set(this.manufacturer, new Uint8Array(manufacturerData.buffer));
            this.beacon.uid = this.beacon.computeUID();
            resolve(this.beacon);
        });
    }
}
exports.BLEAltBeaconBuilder = BLEAltBeaconBuilder;
//# sourceMappingURL=BLEAltBeacon.js.map